import { PaymentOptionType, } from '@debbie/common/dist/collectors/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { CopyToClipboard } from '../../index.js';
import { PaymentId } from './index.js';
const Swift = (props) => {
    const { paymentOption } = props;
    const lang = useSelector((s) => s.lang);
    if (paymentOption.type !== PaymentOptionType.SWIFT) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("h2", null, lang.debtorWebHome.payWithSWIFT),
        React.createElement("p", null, lang.debtorWebHome.paySafeWithSWIFT),
        paymentOption.details?.swiftCode && (React.createElement(PaymentId, null,
            "SWIFT/BIC:",
            React.createElement(CopyToClipboard, { text: `${
                // @ts-ignore
                paymentOption.details.swiftCode}` }, 
            // @ts-ignore
            paymentOption.details.swiftCode))),
        paymentOption.details.ibanCode && (React.createElement(PaymentId, null,
            "IBAN:",
            React.createElement(CopyToClipboard, { text: `${
                // @ts-ignore
                paymentOption.details.ibanCode}` }, 
            // @ts-ignore
            paymentOption.details.ibanCode)))));
};
export default Swift;
//# sourceMappingURL=Swift.js.map